export default __webpack_public_path__ + "static/media/main_section9.4516fade.jpg";